import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {
  OnlineStepNames,
  Origin,
  WebStepNames,
} from '@upstart/harmony/lib/constants';
import { Button } from 'react-bootstrap/lib';
import DealsListFilters from './DealsListFilters';
import ErrorMessage from '../ErrorMessage';
import './DealsList.scss';

function getApplicantName(applicant) {
  if (applicant && applicant.firstName && applicant.lastName) {
    return `${applicant.firstName} ${applicant.lastName}`;
  }
  return 'N/A';
}

function getSalesPersonName(_, deal) {
  if (deal.userFirstName && deal.userLastName) {
    return `${deal.userFirstName} ${deal.userLastName}`;
  }
  return 'N/A';
}

function getProgress(step) {
  return OnlineStepNames[step] || WebStepNames[step];
}

function DealsList(props) {
  const { page, sizePerPage, filterParams, sortParams, onGoToDeal } = props;

  const onFilterChange = newFilterParams => {
    props.filterSortHandler(
      newFilterParams,
      sortParams,
      sizePerPage,
      // reset page on filter change
      null,
    );
  };

  const onPageChange = newPage => {
    props.filterSortHandler(filterParams, sortParams, sizePerPage, newPage);
  };

  const onSortChange = (name, order) => {
    const newSortParams = { name, order };
    props.filterSortHandler(
      filterParams,
      newSortParams,
      sizePerPage,
      // reset page on sort change
      null,
    );
  };

  const onSizePerPageList = newPerPage => {
    props.filterSortHandler(
      filterParams,
      sortParams,
      newPerPage,
      // reset page on size per page change
      null,
    );
  };

  const getDealDetail = row => {
    props.history.push(`/deal/${row.id}`);
  };

  const formatAsDealDetailLink = (_, row) => (
    <span className="deal-id-link" onClick={() => getDealDetail(row)}>
      {row.id}
    </span>
  );

  const EXCLUDED_ORIGINS = [Origin.INSTORE, Origin.DESKING];
  const goToDealButton = (_, row) =>
    EXCLUDED_ORIGINS.includes(row.origin) ? null : (
      <Button onClick={() => onGoToDeal(row)}>Go to deal</Button>
    );

  const tdStyles = { whiteSpace: 'normal', wordBreak: 'break-word' };

  const tableOptions = {
    onPageChange,
    onSizePerPageList,
    sizePerPage: sizePerPage || props.options.defaultPerPage,
    paginationShowsTotal: true,
    sizePerPageList: [5, 10],
    page: page || props.options.defaultPage,
    sortName: sortParams.name,
    sortOrder: sortParams.order,
    onSortChange,
  };

  if (!props.list) {
    return null;
  }

  return (
    <div className="deals-list-container">
      <div className="deals-list-filters">
        <DealsListFilters
          onFilter={onFilterChange}
          onExport={props.exportHandler}
          list={props.list}
          options={props.options}
          filterParams={filterParams}
        />
      </div>
      {props.error && <ErrorMessage error={props.error} />}
      <div className="deals-list-table">
        <BootstrapTable
          data={props.list.data}
          striped
          hover
          remote
          options={tableOptions}
          pagination
          bodyContainerClass="list-body-container"
          tableStyle={{ border: 'none' }}
          fetchInfo={{ dataTotalSize: props.list.total }}
        >
          <TableHeaderColumn
            isKey
            dataField="id"
            dataSort
            tdStyle={tdStyles}
            dataFormat={formatAsDealDetailLink}
          >
            Deal Id
          </TableHeaderColumn>
          <TableHeaderColumn dataField="dealerId" dataSort tdStyle={tdStyles}>
            Dealer
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="applicant"
            dataFormat={getApplicantName}
            tdStyle={tdStyles}
            data-dd-privacy="mask"
            className="amp-mask"
          >
            Customer Name
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="userFirstName"
            dataFormat={getSalesPersonName}
            dataSort
            tdStyle={tdStyles}
            data-dd-privacy="mask"
            className="amp-mask"
          >
            Sales Person
          </TableHeaderColumn>
          <TableHeaderColumn dataField="createdAt" dataSort tdStyle={tdStyles}>
            Created
          </TableHeaderColumn>
          <TableHeaderColumn dataField="updatedAt" dataSort tdStyle={tdStyles}>
            Updated
          </TableHeaderColumn>
          <TableHeaderColumn dataField="origin" dataSort tdStyle={tdStyles}>
            Origin
          </TableHeaderColumn>
          <TableHeaderColumn dataField="car_id" dataSort tdStyle={tdStyles}>
            VIN
          </TableHeaderColumn>
          <TableHeaderColumn dataField="carName" dataSort tdStyle={tdStyles}>
            Car
          </TableHeaderColumn>
          <TableHeaderColumn dataField="result" dataSort tdStyle={tdStyles}>
            Result
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="progress"
            dataFormat={getProgress}
            dataSort
            tdStyle={tdStyles}
          >
            Dropout Step
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="dealLink"
            tdStyle={{ verticalAlign: 'middle' }}
            dataFormat={goToDealButton}
          />
        </BootstrapTable>
      </div>
    </div>
  );
}

DealsList.propTypes = {
  filterSortHandler: PropTypes.func,
  exportHandler: PropTypes.func,
  list: PropTypes.object,
  error: PropTypes.any,
  options: PropTypes.object,
  history: PropTypes.object,
  page: PropTypes.number,
  sizePerPage: PropTypes.number,
  filterParams: PropTypes.object,
  sortParams: PropTypes.object,
  onGoToDeal: PropTypes.func,
};

export default withRouter(DealsList);
